export const getAssessmentIdAPIresponse = async () => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        let _data = "7449860d-458c-4fae-81bb-af673555f725";
        resolve(_data);
      }, 5000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
